import { useEffect } from "react";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { fetchCategoryApiData, fetchProductApiData } from "../../../reduxToolkit/reducers/productSlice";
import Goals from "./Goals";
import JobHomeSection from "./JobHomeSection";
import JobOpenings from "./JobOpenings";
import Service from "./Service";
import TestimonialAndNewsletter from "./TestimonialAndNewsletter";
import Categories from "../common/Categories";

const JobDemo2Container = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchProductApiData());
    dispatch(fetchCategoryApiData());
  }, [dispatch]);
  return (
    <>
      <JobHomeSection />
      <Categories type={"job_demo2"} />
      <JobOpenings />
      <Goals />
      <Service />
      <TestimonialAndNewsletter />
    </>
  );
};

export default JobDemo2Container;
